import { generateContext } from '@btime/react-contexts'
import { gql } from '@apollo/client'
import React, { useContext } from 'react'

import { minicrudsClient } from '../../../utils/apollo/api'
import { usePaginatedQuery } from '../../../utils/apollo/_helpers/pagination'
import LazyAction from '../../../components/helpers/LazyAction'
import StatePresenter from '../../../components/helpers/StatePresenter'

const { StateContext, Provider } = generateContext()
export const useMinicruds = () => useContext(StateContext).minicruds

const QUERY = gql`
  query Minicruds($page: Int, $limit: Int, $search: String, $filter: MinicrudFilter) {
    minicruds(page: $page, limit: $limit, search: $search, filter: $filter, sort: { field: NAME, type: ASC }) {
      id
      name
      entity
    }
  }
`

const MinicrudsLoader = ({ children, search, perPage: limit, uncontrolledChildren, entities }) => {
  const { data, fetchMore, variables, ...state } = usePaginatedQuery(QUERY, {
    variables: {
      page: 1,
      limit: limit || 24,
      search,
      sort: { field: 'NAME', type: 'ASC' },
      filter: { entities }
    },
    client: minicrudsClient
  })
  return (
    <Provider value={data}>
      <StatePresenter {...state} uncontrolledChildren={uncontrolledChildren} empty={false}>
        {children}
      </StatePresenter>
      <LazyAction action={fetchMore} waiting={state.loading} />
    </Provider>
  )
}

export default MinicrudsLoader
